import type { Prototype } from "../prototype-types";

export const mehulPillaiPrototypes: Prototype[] = [
  {
    id: "mp-top-shop-delay-window",
    name: "Top Shop delay window",
    path: "/mp/top-shop-delay-window",
    description:
      "Mockups for the ~2-day qualification delay window: calm 'calculating' headline + 'check back by [date]' across the Top Shop page, home widget, and admin views.",
    owner: "Mehul Pillai",
    createdAt: "2026-05-25",
    lastUpdated: "2026-05-25",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    thumbnail: "https://cdn.prerelease.faire.dev/fastly/73b41f34840af12c1b0081530ade345dbcf3f1ece8f3c066e4cdc42f4be345c6.png",
    creationTool: "claude-code",
  },
];
